import { render } from "./TrendingTokens.vue?vue&type=template&id=5edc07e0&ts=true"
import script from "./TrendingTokens.vue?vue&type=script&lang=ts"
export * from "./TrendingTokens.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__